import React, {Component} from 'react'
import {Nav, Navbar} from "reactstrap";

class NavBarKS extends Component {

	constructor(props) {
		super(props);
		this.state = {
			height: window.innerHeight,
			width: window.innerWidth,
			key: Math.random().toString(36),
			listButtonStyle: {
				pointerEvents: 'none',
				cursor: 'default'
			}
		};
		this.updateDimensions = this.updateDimensions.bind(this);
	}

	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions);
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.selection || !nextProps.btnDisabled) {
			if ((nextProps.selection && nextProps.selection.length !== 0)) {
				this.setState({
					key: Math.random().toString(36),
					listButtonStyle: {
						cursor: 'pointer'
					}
				})
			} else {
				this.setState({
					key: Math.random().toString(36),
					listButtonStyle: {
						pointerEvents: 'none',
						cursor: 'default'
					}
				})
			}
		}
	}

	updateDimensions() {
		this.setState({
			height: window.innerHeight,
			width: window.innerWidth,
			key: Math.random().toString(36)
		});
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
	}

	arrangeLeftButtons(data) {
		let leftButtons = [];
		if (Array.isArray(data)) {
			data.map(ch => {
				if (ch !== null && ch !== undefined && ch.props && ch.props.position === 'leftSide') {
					leftButtons.push(ch)
				}
			});
			if (leftButtons.length > 1) {
				return (
          <div>

            {(this.props.name === 'bordroImport' && this.state.width > 1195) &&
              <div>
              <button className='zocial Gonder' style={{fontSize: 'x-small', marginRight: '5px'}}
                       title="İleti İmzala ve Gönder"
                onClick={() => {
                  {
                    this.props.sign()
                  }
                  {
                    (!this.props.selection || this.props.selection <= 0) &&
                    this.props.showWarning("İletilerinin oluşturulup imzalanması istenen ücret bordrolarını seçiniz.")
                  }
                }}>İmzala & Gönder
              </button>
              <button className='zocial Yenile' style={{fontSize: 'x-small', marginRight: '5px'}}
                      title="İleti İmzala ve Gönder"
                      onClick={() => {
                        this.props.reload(true, "sidebar")
                      }}>Sonuç Yenile
              </button>
              <span className="" style={{position: 'absolute', left: '245px', marginTop: '0'}}>
							<button className="MenuBtn2 listt"
											type="button"
											id="dropdownMenuButton"
											data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								İşlemler
							</button>
							<div className={this.props.flag ? "dropdown-menu show" : "dropdown-menu"}>
								<ul style={{listStyle: 'none', padding: '0', margin: '0'}} >
									{leftButtons.map((ch, i) =>
										ch.props.position === 'leftSide' &&
										<li id="left-dropdown-menu">

											{(ch.type !== 'a' && ch.type.name !== 'ExcelExporter') &&
											<button key={i}
															onClick={ch.props.onClick}
															className={'minimizedButton' + ' ' + ch.props.icon}
															disabled={ch.props.btnDisabled}>
												{!!ch.props.label ? ch.props.label : ch.props.title}
											</button>}

											{(ch.type !== 'a' && ch.type.name === 'ExcelExporter') &&
											<div key={i}>
												<button onClick={ch.props.onClick}
																className={'minimizedButton' + ' ' + ch.props.icon}
																disabled={ch.props.btnDisabled}>
													{!!ch.props.label ? ch.props.label : ch.props.title}
												</button>

												{/*<button	onClick={ch.props.openExcelModalRemote}*/}
												{/*className={'minimizedButton' + ' ' + ch.props.icon}>*/}
												{/*Düzenle ve Excel'e Aktar*/}
												{/*</button>*/}
											</div>}

											{ch.type === 'a' &&
											<a key={i} href={!ch.props.disabled ? ch.props.href : null} download={ch.props.download}
												 style={{fontSize: '1em'}}>
												<button className={'minimizedButton' + ' ' + ch.props.icon}>{ch.props.title}</button>
											</a>}
											{/*<a key={i} className="dropdown-item" onClick={ch.props.onClick} href={ch.props.href}*/}
											{/*year={ch.props.year}*/}
											{/*download={ch.props.download}*/}
											{/*style={ch.props.title === 'Yenile' ? {cursor: 'pointer'} : this.state.listButtonStyle}>*/}
											{/*<i className="fa fa-edit"/> {ch.props.title}*/}
											{/*</a>*/}

										</li>
									)}
								</ul>
							</div>
            </span>
              </div>
            }

						{(this.state.width <= 1195 && this.props.name === 'bordroImport') &&
						<div className="">
							<button className="MenuBtn2 listt"
											type="button"
											id="dropdownMenuButton"
											data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								İşlemler
							</button>
							<div className={this.props.flag ? "dropdown-menu show" : "dropdown-menu"}>
								<ul style={{listStyle: 'none', padding: '0', margin: '0'}}>
									{leftButtons.map((ch, i) =>
										ch.props.position === 'leftSide' &&
										<li id="left-dropdown-menu">

											{(ch.type !== 'a' && ch.type.name !== 'ExcelExporter') &&
											<button key={i}
															onClick={ch.props.onClick}
															className={'minimizedButton' + ' ' + ch.props.icon}
															disabled={ch.props.btnDisabled}>
												{!!ch.props.label ? ch.props.label : ch.props.title}
											</button>}

											{(ch.type !== 'a' && ch.type.name === 'ExcelExporter') &&
											<div key={i}>
												<button onClick={ch.props.onClick}
																className={'minimizedButton' + ' ' + ch.props.icon}
																disabled={ch.props.btnDisabled}>
													{!!ch.props.label ? ch.props.label : ch.props.title}
												</button>

												{/*<button	onClick={ch.props.openExcelModalRemote}*/}
												{/*className={'minimizedButton' + ' ' + ch.props.icon}>*/}
												{/*Düzenle ve Excel'e Aktar*/}
												{/*</button>*/}
											</div>}

											{ch.type === 'a' &&
											<a key={i} href={!ch.props.disabled ? ch.props.href : null} download={ch.props.download}
												 style={{fontSize: '1em'}}>
												<button className={'minimizedButton' + ' ' + ch.props.icon}>{ch.props.title}</button>
											</a>}
											{/*<a key={i} className="dropdown-item" onClick={ch.props.onClick} href={ch.props.href}*/}
											{/*year={ch.props.year}*/}
											{/*download={ch.props.download}*/}
											{/*style={ch.props.title === 'Yenile' ? {cursor: 'pointer'} : this.state.listButtonStyle}>*/}
											{/*<i className="fa fa-edit"/> {ch.props.title}*/}
											{/*</a>*/}

										</li>
									)}
								</ul>
							</div>
						</div>
						  }

						{ (this.props.name !== 'bordroImport') &&
					<div className="">
						<button className="MenuBtn2 listt"
								type="button"
								id="dropdownMenuButton"
								data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							İşlemler
						</button>
						<div className={this.props.flag ? "dropdown-menu show" : "dropdown-menu"}>
							<ul style={{listStyle: 'none', padding: '0', margin: '0'}} >
								{leftButtons.map((ch, i) =>
									ch.props.position === 'leftSide' &&
									<li id="left-dropdown-menu">

										{(ch.type !== 'a' && ch.type.name !== 'ExcelExporter') &&
										<button key={i}
												onClick={ch.props.onClick}
												className={'minimizedButton' + ' ' + ch.props.icon}
												disabled={ch.props.btnDisabled}>
											{!!ch.props.label ? ch.props.label : ch.props.title}
										</button>}

										{(ch.type !== 'a' && ch.type.name === 'ExcelExporter') &&
										<div key={i}>
											<button onClick={ch.props.onClick}
													className={'minimizedButton' + ' ' + ch.props.icon}
													disabled={ch.props.btnDisabled}>
												{!!ch.props.label ? ch.props.label : ch.props.title}
											</button>

											{/*<button	onClick={ch.props.openExcelModalRemote}*/}
											{/*className={'minimizedButton' + ' ' + ch.props.icon}>*/}
											{/*Düzenle ve Excel'e Aktar*/}
											{/*</button>*/}
										</div>}

										{ch.type === 'a' &&
										<a key={i} href={!ch.props.disabled ? ch.props.href : null} download={ch.props.download}
										   style={{fontSize: '1em'}}>
											<button className={'minimizedButton' + ' ' + ch.props.icon}>{ch.props.title}</button>
										</a>}
										{/*<a key={i} className="dropdown-item" onClick={ch.props.onClick} href={ch.props.href}*/}
										{/*year={ch.props.year}*/}
										{/*download={ch.props.download}*/}
										{/*style={ch.props.title === 'Yenile' ? {cursor: 'pointer'} : this.state.listButtonStyle}>*/}
										{/*<i className="fa fa-edit"/> {ch.props.title}*/}
										{/*</a>*/}

									</li>
								)}
							</ul>
						</div>
					</div>
						}
						</div>
				)
			}
			if (leftButtons.length = 1) {
				return leftButtons[0]
			}
		} else {
			return data.props.position === 'leftSide' && data
		}
	}

	arrangeRightButtons(data) {
		let rightButtons = [];
		if (Array.isArray(data)) {
			data.map(ch => {
				if (ch !== null && ch !== undefined && ch.props && ch.props.position === 'rightSide') {
					rightButtons.push(ch)
				}
			});
			if (rightButtons.length > 1) {
				return (
					<div>
						<button className="MenuBtn2 listt"
								style={{padding: '9px 39px 8px 9px'}}
								type="button"
								id="dropdownMenuButton"
								data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							Seçenekler
						</button>
						<div className="dropdown-menu">
							<ul style={{listStyle: 'none', padding: '0', margin: '0'}}>
								{rightButtons.map((ch, i) =>
									ch.props.position === 'rightSide' &&
									<li>

										{ch.type !== 'a' &&
										<button key={i}
												onClick={ch.props.onClick}
												className={'minimizedButton' + ' ' + ch.props.icon}
												disabled={ch.props.btnDisabled}>
											{!!ch.props.label ? ch.props.label : ch.props.title}
										</button>}

										{ch.type === 'a' &&
										<a key={i} onClick={ch.props.onClick} href={!ch.props.disabled ? ch.props.href : null}
										   download={ch.props.download} style={{fontSize: '1em'}}>
											<button className={'minimizedButton' + ' ' + ch.props.icon}>{ch.props.title}</button>
											{/*<i className="fa fa-edit"/> {ch.props.title}*/}
										</a>}
									</li>
								)}
							</ul>
						</div>
					</div>
				)
			}
			if (rightButtons.length = 1) {
				return rightButtons[0]
			}
		} else {
			return data.props.position === 'rightSide' && data
		}
	}

	defineLeftDivSize() {
		if (this.props.name && (this.props.name === 'eInvoiceOutboxList' || this.props.name === 'eInvoiceInboxList'
				|| this.props.name === 'archiveInvoiceList' || this.props.name === 'eDespatchInboxList' || this.props.name === 'eDespatchOutboxList'|| this.props.name === 'DepoIadeList')) {
			return 'col-8';
		} else if (this.props.name === 'invoiceList'){
			return 'col-10';
		} else {
			return 'col-8'; // simdilik her iki kosul ayni birakildi ilerde sayfa bazinda degisiklige ugrayabilir
		}
	}

	defineRightDivSize() {
		if (this.props.name && (this.props.name === 'eInvoiceOutboxList' || this.props.name === 'eInvoiceInboxList'
				|| this.props.name === 'archiveInvoiceList' || this.props.name === 'eDespatchInboxList' || this.props.name === 'eDespatchOutboxList' || this.props.name === 'DepoIadeList')) {
			return 'col-4';
		} else if (this.props.name === 'invoiceList'){
			return 'col-2';
		} else {
			return 'col-4'; // simdilik her iki kosul ayni birakildi ilerde sayfa bazinda degisiklige ugrayabilir
		}
	}

	defineWidthByPage() {
		let pageName = this.props.name;

		switch (pageName) {
			case 'eInvoiceOutboxList':
			case 'archiveInvoiceList':
			case 'DepoIadeList':
			case 'eDespatchOutboxList':
			case 'mVoucherList':
			case 'archiveVoucher':
			case 'sigorta':
				return 1000;
			case 'eInvoiceInboxList':
			case 'eDespatchInboxList':
				return 1245;
			case 'eInvoiceOutboxTransferList':
			case 'eInvoiceInboxTransferList':
			case 'archiveInvoiceTransferList':
			case 'creditList':
			case 'requestMessageList':
			case 'stockList':
			case 'xsltList':
			case 'progressPayment':
			case 'externalCustomerList':
			case 'customer':
			case 'excelRequestWithLine':
			case 'excelRequestForSgkCiro':
			case 'excelRequest':
			case 'financeSealList':
				return 650;
			case 'createEditInvoice':
			case 'createEditVoucher':
			case 'createEditDespatch':
			case 'despatchList':
			case 'invoiceList':
			case 'createEditBelge':
			case 'belgeTmp':
			case 'voyageDocumentList':
			case 'sigortaTmp':
				return 1280;
			case 'accountsPage':
			case 'sVoucherList':
				return 700;
			case 'bordroImport':
        return 3000000;
		}
	}

	render() {

		let right = this.state.width > 991 ? (this.props.offsetWidth === null || this.props.offsetWidth === 24) ? {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			paddingRight: '195px'
		} : {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center'
		} : {float: 'right'};

		return (
			<div key={this.state.key} style={{position: 'absolute', top: '0px'}}>

				<Navbar className={this.props.className?this.props.className + " topbar filter-sticky-container":"topbar filter-sticky-container"}>
					<div className="col-sm-12 col-12 row">
						{this.state.width >= this.defineWidthByPage() ?
							<div className={this.defineLeftDivSize()} style={{paddingRight: '0'}}>
								<Nav>
									{Array.isArray(this.props.children) ? this.props.children.filter(ch => {
										return ch !== null && ch !== undefined && ch.props && ch.props.position === 'leftSide'
									}) : (this.props.children && this.props.children.props.position === 'leftSide') && this.props.children}
								</Nav>
							</div> :
							<div className={this.defineLeftDivSize() + " topBarLeftButtonDropdownDiv"}
								 style={{paddingRight: '0'}}>
								{this.props.children && this.arrangeLeftButtons(this.props.children)}
							</div>}

						{
							this.props.children && Array.isArray(this.props.children) &&
							<div style={{
								position: 'absolute',
								left: 0,
								right: 0,
								marginLeft: "auto",
								marginRight: 'auto',
								width: '100px',
								paddingLeft: '6px'
							}}>
								{this.props.children.filter(ch => {
									return ch !== null && ch !== undefined && ch.props && ch.props.position === 'seperate'
								})}
							</div>
						}

						<div className={this.defineRightDivSize() + " topBarRightButtonDropdownDiv"}
							 style={{paddingLeft: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
							{this.state.width >= 1280 ?
								<div style={right}>
									<Nav>
										{Array.isArray(this.props.children) ? this.props.children.filter(ch => {
											return ch !== null && ch !== undefined && ch.props && ch.props.position === 'rightSide'
										}) : (this.props.children && this.props.children.props.position === 'rightSide') && this.props.children}
									</Nav>
								</div> :
								<div>
									{this.props.children && this.arrangeRightButtons(this.props.children)}
								</div>}
						</div>
					</div>
				</Navbar>
			</div>
		)
	}
}

export default NavBarKS;